import React from "react";
import { NavLink } from "react-router-dom";
import image from "./../../images/img1.png";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { compareState } from "../../store/CompareState";
import { useRecoilState } from "recoil";
import RetryableImage from "../retryableImage/RetryableImage";
const Productcard = styled.div`
  border: 1px solid ${window.ENV.GENERAL.PRODUCT_GRID_BOARDER_COLOR};
  padding: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  transition: transform 0.3s;
  display: flex;
  flex-direction: column;
  width : 500px;
  border-radius: 8px;
    &:hovor {
    transform: translateY(-5px);
  }
`;
const Productcontent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
`;

const Imagecontainer = styled.div`
  display: flex;
  margin-right: 10px;
`;

const Productimgmanufacture = styled.img`
  width: 100%;
  height: 250px;
  object-fit: contain;
`;

const Textcontainer = styled.div`
  width: 60%;
`;

const Producttitle = styled.h3`
  margin-bottom: 20px !important;
  margin-top: 0px;
  // font-family: 'UP-Light', sans-serif;
  // font-weight: 300;

  font-size: 1.3rem;
  color: #003063;
  width: 100%;
  word-wrap: break-word;
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
`;

const Producttitlename = styled.h4`
  border-bottom: 1px solid #cecece;
  padding: 0.92em 0;
  margin-bottom: 0px;
  font-size: 0.85em;
  padding-bottom: 0px;
  color: #333;
  // font-family: 'UP-Light', sans-serif;
  transition: opacity 0.5s linear;
  font-weight: 300;
`;

const ProducttitlenameBold = styled.h4`
  border-bottom: 1px solid #cecece;
  padding: 0.92em 0;
  margin-bottom: 0px;
  font-size: 0.85em;
  padding-bottom: 0px;
  color: #333;
  // font-family: 'UP-Light', sans-serif;
  transition: opacity 0.5s linear;
  font-weight: 900;
`;

const Productlabel = styled.p`
  border-top: 1px solid #cecece;
  padding: 0.62em 0;
  font-size: 0.85em;
  padding-bottom: 0px;
  font-weight: 700;
  color: #333;
  // font-family: Source Sans Pro, Arial;
`;
const Addmorelink = styled.h6`
  color: #333;
  border-top: 1px solid #cecece;
  padding: 0.62em 0;
  margin-bottom: 0;
  font-size: 0.85em;
  cursor: pointer;
  text-decoration: none !important;
  margin-top: 0px;
  // font-family: Source Sans Pro, Arial;
  font-weight: 300;
`;

const Comparemanufact = styled.p`
  font-size: 16px;
  font-weight: 400;
  // line-height: 14.66px;

  text-align: left;
  margin-top: 0px;
  cursor: pointer;
  // text-decoration: underline;
`;

const ImageOnLeft = ({ categoryName, product, specifications }) => {
  // const { addToCompare, removeFromCompare,compareList } = useCompare(); // Using the compare context
  // const [isSelected, setIsSelected] = useState(false);
  const [compareProducts, setCompareProducts] = useRecoilState(compareState);
  const [isSelected, setIsSelected] = useState(
    compareProducts.some((item) => item.productId === product.productId)
  );
  //console.log("specifications:", specifications);
  useEffect(() => {
    // Reset the selection state if the compare list changes (such as being cleared)
    setIsSelected(
      compareProducts.some((item) => item.productId === product.productId)
    );
  }, [compareProducts]); // Re-run effect when compareList changes
  // const handleCompareToggle = () => {
  //   setIsSelected(!isSelected);
  //   if (!isSelected) {
  //     addToCompare(product); // Add product to compare list
  //   } else {
  //     removeFromCompare(product.productId); // Remove product from compare list
  //   }
  // };
  const handleCompareToggle = () => {
    if (isSelected) {
      removeFromCompare(product.productId);
    } else {
      addToCompare(product);
    }
    setIsSelected(!isSelected);
  };

  const addToCompare = (product) => {
    if (compareProducts.length < window.ENV.COMPARE_TOTAL_ITEM) {
      setCompareProducts((prev) => [...prev, product]);
    } else {
      alert("You can only compare up to ${window.ENV.COMPARE_TOTAL_ITEM} products.");
    }
  };

  // Remove product from compare list
  const removeFromCompare = (productId) => {
    setCompareProducts((prev) =>
      prev.filter((item) => item.productId !== productId)
    );
  };

  // Disable checkbox if compare list has reached its limit
  const isCompareDisabled =
    compareProducts.length >= window.ENV.COMPARE_TOTAL_ITEM && !isSelected;

  //console.log("product:", product);

  const specKeys = specifications?.split(",").map((key) => key.trim());

  let filteredItems;

  if (window.ENV.PRODUCT_LIST_TABLE_VIEW_COLUMNS_FROM_SHEET) {
    // Use specKeys, no slice
    filteredItems = window.ENV.PRODUCT_LIST_ITEMS
      .filter((item) => specKeys?.includes(item.VALUE))
      .map((item) => ({
        label: item.LABEL,
        value: product[item.VALUE],
      }))
      .filter(({ value }) => value !== null && value !== undefined && value !== "");
  } else {
    // Use all items, slice to first 5
    filteredItems = window.ENV.PRODUCT_LIST_ITEMS
      .map((item) => ({
        label: item.LABEL,
        value: product[item.VALUE],
      }))
      .filter(({ value }) => value !== null && value !== undefined && value !== "")
      .slice(0, 5);
  }

  //console.log(window.ENV.SERVER_URL, product.isometric_view);


  return (
    <Productcard key={product.productId}>
      <>
        <NavLink
          to={`/category/${categoryName}/productdetails/${product.productId}`}
          state={{ productlabel: product.Label }}
          style={{ textDecoration: "none" }} // Optional: Remove underline from link
        >
          <Productcontent>
            <Imagecontainer>
              {/* <Productimgmanufacture
                src={`${window.ENV.SERVER_URL}${product.isometric_view}`}
                alt={product.productId || "Product Image"}
              /> */}
              <RetryableImage
                src={`${window.ENV.SERVER_URL}${product.isometric_view}`}
                alt={product.productId || "Product Image"}
                maxRetries={window.ENV.MAX_RETRIES || 10}
                retryDelay={window.ENV.RETRY_DELAY || 5000}
              />
            </Imagecontainer>

            <Textcontainer>
              <Producttitle>
                {product[window.ENV.PRODUCT_LIST_HEADER.COLUMN] || "No Product No"}
              </Producttitle>
              {filteredItems.map(({ label, value }, idx) => (
                <Producttitlename key={idx}>
                  {label && `${label}: `}
                  {value}
                </Producttitlename>
              ))}
            </Textcontainer>
          </Productcontent>
        </NavLink>
        {window.ENV.SHOW_COMPARE && (
          <Comparemanufact>
            <input
              type="checkbox"
              checked={isSelected}
              onChange={handleCompareToggle}
              disabled={isCompareDisabled}
            />{" "}
            Compare
          </Comparemanufact>
        )}
      </>
    </Productcard>
  );
};

export default ImageOnLeft;
